import { getUrlParam } from "./store/helpers";
import { cacheTenant, readTenant } from "./utils/tenantStorage";
export function getIsCrane() {
    const craneFromUrl = getUrlParam("crane");
    if (craneFromUrl === "true") {
        sessionStorage.setItem("crane", "true");
        return true;
    }
    if (getUrlParam("tenant")) {
        sessionStorage.removeItem("crane");
        return false;
    }
    return sessionStorage.getItem("crane") === "true";
}
export function getMsTenantFromUrl() {
    const urlTenant = getUrlParam("tenant");
    if (urlTenant && urlTenant.trim() !== "") {
        const trimmedUrlTenant = urlTenant.trim();
        cacheTenant(trimmedUrlTenant);
        return trimmedUrlTenant;
    }
    else if (urlTenant?.trim() === "") {
        sessionStorage.removeItem("tenant");
        return null;
    }
    return readTenant();
}
export function msalConfig(tenant) {
    return {
        auth: {
            clientId: "da20dc94-4aa1-45dc-baa1-c5d8c23215c1",
            authority: `https://login.microsoftonline.com/${tenant}`,
            redirectUri: `${window.location.origin}/redirect.html`,
            postLogoutRedirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: "localStorage",
        },
    };
}
export const loginRequest = {
    scopes: ["openid", "profile", "offline_access"],
};
